var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.076 23.5742C147.853 43.2275 156.002 74.9751 145.506 103.169C135.01 131.363 108.084 150.053 78.0002 150.027V150.027C57.0902 150.034 37.2167 140.922 23.5775 125.073",
    stroke: "#8DA8FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53962 96.8089C1.69689 71.9132 8.74664 45.2606 27.0034 27.0038C45.2601 8.74712 71.9128 1.69737 96.8084 8.54011",
    stroke: "#8DA8FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFora);
export default __webpack_public_path__ + "static/media/fora.8ad0ac78f9b329d65c68436eeb24b892.svg";
export { ForwardRef as ReactComponent };